export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/usNews.f8994bb5.svg","height":20,"width":91,"blurWidth":0,"blurHeight":0};